import React from "react";
import { StaffListConstants } from "../constants/constants";
import WarningIcon from "../assets/images/WarningIcon";
import NotificationIconForLogin from "../assets/images/NotificationIconForLogin";

interface MobileResponsivePopupModalProps {
  content: any;
  onClose: () => void;
  style: any;
  icon?: any;
}

const MobileResponsivePopupModal: React.FC<MobileResponsivePopupModalProps> = ({
  content,
  onClose,
  style,
  icon = <NotificationIconForLogin />,
}) => {
  return (
    <div
      className={`fixed inset-0 z-50  flex items-center justify-center  ${style.backGroundStyle}`}
    >
      <div className={` flex flex-col items-center  ${style.modalstyle}`}>
        <div className="flex justify-center items-center pb-4 ">{icon}</div>
        <div className="text-popUpTitleColor loginPopup px-14 text-center  whitespace-nowrap font-poppins">
          {content.title}
        </div>
        <div className="body1 text-loginSubTitle text-center mt-3">
          {content.message}
        </div>

        <div className="mt-6 flex justify-center">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-primary text-white  rounded-lg hover:bg-primary-dark"
          >
            {StaffListConstants.Okay}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileResponsivePopupModal;
